module.exports = __webpack_public_path__ + "static/img/about_card03.9fad08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_card03.png
// module id = DGOw
// module chunks = 2